import { MetricCell } from "components/designV2/metricCell/metricCell";
import { useTranslation } from "react-i18next";
import { formatDuration } from "utils/utils";
import { SalaryNotice } from "model/Salary";
import { SummaryGrid } from "./individualSalary.styled";

type Props = {
  salaryNotices: SalaryNotice[];
  selectedYear: number;
};

export const SummaryIndividualSalary: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const totalGrossSalary = props.salaryNotices.reduce(
    (sum, notice) => sum + notice.grossSalary,
    0,
  );
  const totalPreliminaryTax = props.salaryNotices.reduce(
    (sum, notice) => sum + notice.preliminaryTax,
    0,
  );
  const totalNetSalary = props.salaryNotices.reduce(
    (sum, notice) => sum + notice.netSalary,
    0,
  );
  const totalWorkedHours = props.salaryNotices.reduce(
    (sum, notice) => sum + notice.workedHours,
    0,
  );
  const totalPayrollTax = props.salaryNotices.reduce(
    (sum, notice) => sum + notice.payrollTax,
    0,
  );
  const totalDeductionAmount = props.salaryNotices.reduce(
    (sum, notice) => sum + notice.deductionAmount,
    0,
  );

  const currency = props.salaryNotices[0].currency === "SEK" ? " kr" : "";

  return (
    <SummaryGrid>
      <div aria-hidden />
      <MetricCell
        value={formatDuration(totalWorkedHours.toString())}
        label={t("Salary.TotalWorkTime")}
      />
      <MetricCell
        value={`${totalGrossSalary.toFixed(2)}${currency}`}
        label={t("Salary.TotalGrossSalary")}
      />
      <MetricCell
        value={`${totalNetSalary.toFixed(2)}${currency}`}
        label={t("Salary.TotalNetSalary")}
      />
      <MetricCell
        value={`${totalPreliminaryTax.toFixed(2)}${currency}`}
        label={t("Salary.TotalTax")}
      />
      <MetricCell
        value={`${totalPayrollTax.toFixed(2)}${currency}`}
        label={t("Salary.TotalPayrollTax")}
      />
      <MetricCell
        value={`${totalDeductionAmount}${currency}`}
        label={t("Salary.TotalDeductionAmount")}
      />
      <div aria-hidden />
    </SummaryGrid>
  );
};
